import Table from '@components/table'
import TableActions from '@components/table/actions'
import { Medicine } from '@apis'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { format } from 'date-fns'
import Alert from '@commons/popups/alert'
import { useNavigate } from 'react-router-dom'
import { Formik } from 'formik'
import Fields from '@components/fields'
import Row from '@components/row'
import Column from '@components/column'
import Svg from '@components/svg'
import download from '@utils/download'
const List = () => {
  const navigate = useNavigate()
  const { items: medicines, loading } = useSelector(
    (state: any) => state.medicines,
  )
  const [params, setParams] = useState({
    page: 1,
    limit: 10,
  })
  const [deleteInfo, setDeleteInfo] = useState({
    visible: false,
    id: null,
    loading: false,
  })
  const fetchData = async () => {
    await Medicine.list({
      params,
    }).catch(() => {})
  }

  const removeData = async () => {
    setDeleteInfo({
      ...deleteInfo,
      loading: true,
    })
    await Medicine.remove({
      id: deleteInfo?.id,
    })
      .then(() => {
        navigate('.')
      })
      .catch(() => {})
    setDeleteInfo({
      ...deleteInfo,
      visible: false,
      loading: false,
    })
  }

  const columns: any = [
    {
      key: 'category',
      title: 'Category',
      render: (item: any) => {
        return item.category.name
      },
    },
    {
      key: 'subCategory',
      title: 'Sub Category',
      render: (item: any) => {
        return item.subCategory.name
      },
    },
    {
      key: 'fileName',
      title: 'File Name',
    },
    {
      key: 'createdAt',
      title: 'Added  Date',
      render: (item: any) => {
        return format(item?.createdAt, 'MMM dd yyyy')
      },
    },
    {
      key: 'status',
      title: 'Active Status',
      render: (item: any) => {
        return (
          <Formik
            initialValues={{
              status: item?.status,
            }}
            onSubmit={() => {}}
          >
            {() => {
              return (
                <Fields.Switch
                  name="status"
                  onChange={async (value) => {
                    await Medicine.update({
                      id: item?.id,
                      data: {
                        status: value,
                      },
                    })
                  }}
                />
              )
            }}
          </Formik>
        )
      },
    },
    {
      key: 'actions',
      title: 'Actions',
      render: (item: any) => {
        return (
          <Row colGap={10} alignItems="center">
            <Column
              onClick={() => {
                download(item?.file)
              }}
            >
              <Svg svg="download" size={24} color={'success'} />
            </Column>
            <TableActions
              hasView={false}
              onClickEdit={() => {
                navigate('/admin/medicine-management', {
                  state: item,
                })
              }}
              onClickDelete={() => {
                setDeleteInfo({
                  visible: true,
                  id: item?.id,
                  loading: false,
                })
              }}
            />
          </Row>
        )
      },
    },
  ]

  useEffect(() => {
    if (!medicines?.length) {
      fetchData()
    }
  }, [])
  return (
    <>
      <Table data={medicines} columns={columns} loading={loading} />
      <Alert
        visible={deleteInfo?.visible}
        loading={deleteInfo?.loading}
        onClickOk={removeData}
        onClickClose={() => {
          setDeleteInfo({
            visible: false,
            id: null,
            loading: false,
          })
        }}
      />
    </>
  )
}

export default List
